module.exports = __webpack_public_path__ + "static/media/guandao_pic2.7b530dcb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/guandao_pic2.jpg
 ** module id = 438
 ** module chunks = 0
 **/